import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { MOODS, MOCK_WALLPAPERS, REVIEWS, categorySlugById, spaceSlugById } from '../../models/constants';
import { Wallpaper, JourneyContext, INITIAL_CONTEXT, MasterItem } from '../../models/wallpaper.model';
import { WallpaperService } from '../../services/wallpaper.service';
import { DataLayerService } from '../../services/datalayer.service';
import { TriggerService } from '../../services/trigger.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  categories: MasterItem[] = [];

  private readonly S = 'https://storage.googleapis.com/static-mahattaart-online/spaces/';
  spaces: any[] = [
    { id: 8,  display_name: 'Living Room',       slug: 'living-room',           images: [this.S + 'Living Room.png'] },
    { id: 9,  display_name: 'Bedroom',            slug: 'bedroom',               images: [this.S + 'Bedroom.jpg'] },
    { id: 13, display_name: 'Bathroom',           slug: 'bathroom',              images: [this.S + 'Bathroom.jpg'] },
    { id: 10, display_name: 'Dining Room',        slug: 'dining-room',           images: [this.S + 'Dinning Room.jpg'] },
    { id: 11, display_name: 'Kids Room',          slug: 'kids-room',             images: [this.S + 'Kids Room.jpg'] },
    { id: 26, display_name: 'Pooja Room',         slug: 'pooja-room',            images: [this.S + 'Pooja Room.jpg'] },
    // { id: 24, display_name: 'Gym / Fitness',      slug: 'home-gym',              images: [] },
    // { id: 77, display_name: 'Home Office / Study', slug: 'home-offices-study',   images: [this.S+'Office.jpg'] },
    // { id: 78, display_name: 'Foyer',              slug: 'hallways-entryways',    images: [] },
    { id: 79, display_name: 'Office', slug: 'offices-corporate',     images: [this.S + 'Office.jpg'] },
    // { id: 80, display_name: 'Retail & Showroom',  slug: 'retail-stores',         images: [] },
    { id: 81, display_name: 'Cafe & Restaurant',  slug: 'restaurants-cafes-pubs', images: [this.S + 'Restaurant.png'] },
    { id: 82, display_name: 'Hotels & Resorts',   slug: 'hotels-resorts',        images: [this.S + 'Hotel & Resort.jpeg'] },
    { id: 83, display_name: 'Spa & Salon',        slug: 'salons-spas-wellness',  images: [this.S + 'Spa.jpg'] },
    // { id: 84, display_name: 'Healthcare',         slug: 'healthcare-clinics',    images: [] },
    // { id: 85, display_name: 'Galleries & Museums', slug: 'art-galleries',        images: [] },
    // { id: 86, display_name: 'Event Spaces',       slug: 'event-venues',          images: [] },
  ];
  moods = MOODS;
  reviews = REVIEWS;
  starsArray = [1, 2, 3, 4, 5];

  // Top banner carousel (static)
  bannerSlides = [
    { image: 'https://storage.googleapis.com/static-mahattaart-online/banner/SM_Wall-Art-Banner_03.webp', mobile_image: '', link: '' },
    { image: 'https://storage.googleapis.com/static-mahattaart-online/banner/SM_P2F-Banner_07%20(1).webp', mobile_image: '', link: '' }
  ];
  bannerSlideIndex = 0;
  private bannerTimer: any;

  // Hero banner slider
  heroBanners = [
    {
      image: 'https://storage.googleapis.com/static-mahattaart-online/banner/SM_Wallpaper-Banner_MAWP-C-2392.webp',
      wallpaperId: 'botanical-flowers-leaves-circles-beige-brown',
      alt: 'Premium Wallpaper MAWP-C-2392'
    }
  ];
  heroSlideIndex = 0;
  private heroAutoTimer: any;
  private readonly heroAutoDelay = 400000;

  // Review slider
  reviewSlideIndex = 0;
  reviewVisibleCount = 3;
  noTransition = false;
  private reviewAutoTimer: any;
  private readonly reviewAutoDelay = 7000;

  userType: 'new' | 'existing' = 'new';
  context: JourneyContext = { ...INITIAL_CONTEXT };
  wishlistIds = new Set<string>();

  @ViewChild('categoryScrollRef') categoryScrollEl!: ElementRef<HTMLDivElement>;
  @ViewChild('spaceScrollRef') spaceScrollEl!: ElementRef<HTMLDivElement>;
  @ViewChild('exclusiveScrollRef') exclusiveScrollEl!: ElementRef<HTMLDivElement>;

  private sub = new Subscription();
  private observer!: IntersectionObserver;

  // Dynamic thumbnail maps built from API wallpaper data (category/space id → image url)
  categoryThumbnails: Record<number, string> = {};
  spaceThumbnails: Record<number, string> = {};

  // Hardcoded categories with 5 rotating images each (all static bucket URLs — no generation params)
  private readonly L = 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/';
  private readonly L1 = 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new1/';

  private readonly Category = 'https://storage.googleapis.com/static-mahattaart-online/category/';

  hardcodedCategories: { id: number; name: string; display_name: string; slug: string; images: string[] }[] = [
    { id: 2,  name: 'Modern & Contemporary',         display_name: 'Modern',               slug: 'modern',              images: [this.Category + 'Modern.jpg'] },
    { id: 5,  name: 'Floral & Botanical',             display_name: 'Floral',              slug: 'florals',             images: [this.Category + 'Floral.jpg'] },
    { id: 7,  name: 'Geometric & Abstract Patterns',  display_name: 'Abstract & Geometrics', slug: 'abstract-geometrics', images: [this.Category + 'Abstract.jpg'] },
    { id: 8,  name: 'Illustrative & Narrative',       display_name: 'Art',                  slug: 'art',                 images: [this.Category + 'Art.jpg'] },
    { id: 9,  name: 'Scenic & Architectural',         display_name: 'Scenic',               slug: 'scenic',              images: [this.Category + 'Scenic.jpg'] },
    { id: 10, name: 'Animal & Fauna',                 display_name: 'Animals',              slug: 'animals',             images: [this.Category + 'Animals.jpg'] },
    { id: 14, name: 'Kids & Playful Interiors',       display_name: 'Kids',                 slug: 'kids',                images: [this.Category + 'Kids.jpg'] },
    { id: 15, name: 'Mythological & Symbolic',        display_name: 'Spiritual',            slug: 'spiritual',           images: [this.Category + 'spritual.jpg'] },
    { id: 18, name: 'Nature & Tranquil Interiors',    display_name: 'Nature',               slug: 'nature',              images: [this.Category + 'Nature.jpg'] },
    { id: 25, name: 'Textile & Handcrafted',          display_name: 'Textile',              slug: 'textile',             images: [this.Category + 'Textile.jpg'] },
    { id: 31, name: 'Abstract Texture',               display_name: 'Textures',             slug: 'textures',            images: [this.Category + 'textured.jpg'] },
    { id: 36, name: 'CITIES & MAPS',                  display_name: 'Cities & Maps',        slug: 'cities-maps',         images: [this.Category + 'Cities and maps.jpg'] },
    { id: 37, name: 'CLASSIC & VINTAGE',              display_name: 'Classic & Vintage',    slug: 'classic-vintage',     images: [this.Category + 'Classic & Vintage.jpg'] },
    { id: 38, name: 'Photorealistic and Natural',     display_name: 'Photographic',         slug: 'photographic',        images: [this.Category + 'Photographic.jpg'] },
    { id: 42, name: 'MIDDLE EASTERN',                 display_name: 'Middle Eastern',       slug: 'middle-eastern',      images: [this.Category + 'Middle east.png'] },
    { id: 43, name: 'SOUTH EAST ASIAN',               display_name: 'South East Asian',     slug: 'south-east-asian',    images: [this.Category + 'SOUTH EAST ASIAN.png'] },
    { id: 44, name: 'EAST ASIAN',                     display_name: 'East Asian',           slug: 'east-asian',          images: [this.Category + 'East Asian.jpeg'] },
    { id: 45, name: 'SILK ROUTE',                     display_name: 'Silk Route',           slug: 'silk-route',          images: [this.Category + 'silk route.png'] },
    { id: 46, name: 'INDIAN Heritage',                display_name: 'Indian Heritage',      slug: 'indian-heritage',     images: [this.Category + 'indian heritage.jpg'] },
  ];

  // Static image fallback maps keyed by slug
  private readonly categoryImages: Record<string, string> = {
    'modern': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1921_low_1772048375129.jpg',
    'floral': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new1/SM-Nouv-0027_0.jpg',
    'florals': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new1/SM-Nouv-0027_0.jpg',
    'floral-pattern': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new1/SM-Nouv-0027_0.jpg',
    'abstract': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1769_low_1772046872915.jpg',
    'abstract-geometrics': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1769_low_1772046872915.jpg',
    'abstract-geometric': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1769_low_1772046872915.jpg',
    'geometric': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1769_low_1772046872915.jpg',
    'art': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2142_low_1772053262564.jpg',
    'arts': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2142_low_1772053262564.jpg',
    'scenic': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1828_low_1772047739973.jpg',
    'scenery': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1828_low_1772047739973.jpg',
    'landscape': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1828_low_1772047739973.jpg',
    'kids': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1740_low_1772046369981.jpg',
    'kids-room': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1740_low_1772046369981.jpg',
    'children': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1740_low_1772046369981.jpg',
    'animals': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2218_low_1772056002469.jpg',
    'animal': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2218_low_1772056002469.jpg',
    'wildlife': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2218_low_1772056002469.jpg',
    'spiritual': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1999_low_1772050148050.jpg',
    'spirituality': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1999_low_1772050148050.jpg',
    'religious': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1999_low_1772050148050.jpg',
    'nature': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1730_low_1772046156689.jpg',
    'natural': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1730_low_1772046156689.jpg',
    'textile': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-P-2254_low_1772056646839.jpg',
    'textures': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/SM_Gabb_0060_15x10_C1_C_low_1771220625329.jpg',
    'texture': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/SM_Gabb_0060_15x10_C1_C_low_1771220625329.jpg',
    'cities-maps': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1332_low_1772043956324.jpg',
    'cities': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1332_low_1772043956324.jpg',
    'city': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1332_low_1772043956324.jpg',
    'maps': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1332_low_1772043956324.jpg',
    'classic-vintage': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2344_low_1771589557696.jpg',
    'classic': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2344_low_1771589557696.jpg',
    'vintage': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2344_low_1771589557696.jpg',
    'photographic': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2230_low_1772056296997.jpg',
    'photography': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2230_low_1772056296997.jpg',
    'photo': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2230_low_1772056296997.jpg',
    'middle-eastern': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2331_low_1771588840241.jpg',
    'middle-east': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2331_low_1771588840241.jpg',
    'east-asian': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2353_low_1771590194088.jpg',
    'east-asia': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2353_low_1771590194088.jpg',
    'indian-heritage': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2169_low_1772054582239.jpg',
    'traditional': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2169_low_1772054582239.jpg',
    'heritage': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2169_low_1772054582239.jpg',
    'south-east-asian': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/SM_Ikat_0054_35x35_C1_P_low_1770800894314.jpg',
    'south-east-asia': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/SM_Ikat_0054_35x35_C1_P_low_1770800894314.jpg',
    'silk-route': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2476_low_1771653899909.jpg',
    'silk': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-2476_low_1771653899909.jpg',
    'misc': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1921_low_1772048375129.jpg',
    'miscellaneous': 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new_latest/MAWP-C-1921_low_1772048375129.jpg',
  };

  private readonly spaceImages: Record<string, string> = {
    'living-room': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-1733_0.jpg?generation=1768288053960446&alt=media',
    'living': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-1733_0.jpg?generation=1768288053960446&alt=media',
    'lounge': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-1733_0.jpg?generation=1768288053960446&alt=media',
    'bedroom': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2353_0.jpg?generation=1771830549850949&alt=media',
    'bed-room': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2353_0.jpg?generation=1771830549850949&alt=media',
    'master-bedroom': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2353_0.jpg?generation=1771830549850949&alt=media',
    'bathroom': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-P-2343_0.jpg?generation=1771481705307422&alt=media',
    'bath': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-P-2343_0.jpg?generation=1771481705307422&alt=media',
    'washroom': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-P-2343_0.jpg?generation=1771481705307422&alt=media',
    'dining-room': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2374_0.jpg?generation=1772000120285992&alt=media',
    'dining': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2374_0.jpg?generation=1772000120285992&alt=media',
    'kids-room': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper-mockup-thumbnail%2FMAWP-C-2105_space1_MKP-2025-050.png?generation=1765894596058132&alt=media',
    'kids': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper-mockup-thumbnail%2FMAWP-C-2105_space1_MKP-2025-050.png?generation=1765894596058132&alt=media',
    'children': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper-mockup-thumbnail%2FMAWP-C-2105_space1_MKP-2025-050.png?generation=1765894596058132&alt=media',
    'nursery': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper-mockup-thumbnail%2FMAWP-C-2105_space1_MKP-2025-050.png?generation=1765894596058132&alt=media',
    'pooja-room': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2003_0.jpg?generation=1772005357000531&alt=media',
    'pooja': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2003_0.jpg?generation=1772005357000531&alt=media',
    'puja': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2003_0.jpg?generation=1772005357000531&alt=media',
    'prayer': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-2003_0.jpg?generation=1772005357000531&alt=media',
    'restaurant': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2357_0.jpg?generation=1771912835184045&alt=media',
    'restaurants': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2357_0.jpg?generation=1771912835184045&alt=media',
    'cafe': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2357_0.jpg?generation=1771912835184045&alt=media',
    'cafes': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2357_0.jpg?generation=1771912835184045&alt=media',
    'pub': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2357_0.jpg?generation=1771912835184045&alt=media',
    'restaurants-cafes-pubs': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2357_0.jpg?generation=1771912835184045&alt=media',
    'hotels-resorts': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2342_0.jpg?generation=1771824594826529&alt=media',
    'hotel': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2342_0.jpg?generation=1771824594826529&alt=media',
    'resort': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2342_0.jpg?generation=1771824594826529&alt=media',
    'spa': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2327_0.jpg?generation=1771819565872275&alt=media',
    'salon': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2327_0.jpg?generation=1771819565872275&alt=media',
    'salons': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2327_0.jpg?generation=1771819565872275&alt=media',
    'wellness': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2327_0.jpg?generation=1771819565872275&alt=media',
    'salons-spas-wellness': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2327_0.jpg?generation=1771819565872275&alt=media',
    'office': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'offices': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'offices-corporate': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'corporate': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'work': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'home-offices-study': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'study': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'home-office': 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Fspace2_MAWP-C-2312_0.jpg?generation=1771817771664841&alt=media',
    'kitchen': 'https://storage.googleapis.com/mahattaart-wallpaper/Kitchen.png',
  };

  quickRooms = [
    { name: 'Bedroom', image: 'https://storage.googleapis.com/mahattaart-wallpaper/Striking%20Bedroom%20Wallpapers.jpg' },
    { name: 'Living Room', image: 'https://storage.googleapis.com/mahattaart-wallpaper/Bold%20Living%20Room%20Wallpaper.png' },
    { name: 'Offices & Corporate', image: 'https://storage.googleapis.com/mahattaart-wallpaper/Office.jpg' },
  ];

  // Exclusive wallpapers — list driven by backend setting `home.wallpaper_product.0.title`
  exclusiveWallpapers: any[] = [];

  popularWallpapers: any[] = [];

  /**
   * Rail load state. Both rails start true so the first paint shows placeholders
   * instead of an empty strip that silently fills in — these hit the network, and a
   * blank gap reads as "nothing here" rather than "loading".
   *
   * Set false on error as well as success. Neither call had an error handler at
   * all, so a failed request left the rail empty forever with nothing said.
   */
  exclusiveLoading = true;

  popularLoading = true;


  existingUser = {
    name: 'Sarah',
    loyaltyPoints: 2450,
    recentlyViewed: [MOCK_WALLPAPERS[0], MOCK_WALLPAPERS[1], MOCK_WALLPAPERS[3], MOCK_WALLPAPERS[6]],
    pastPurchaseCategory: 'Modern',
    recommendations: [MOCK_WALLPAPERS[5], MOCK_WALLPAPERS[0], MOCK_WALLPAPERS[6], MOCK_WALLPAPERS[2]],
    lastOrder: { wallpaper: MOCK_WALLPAPERS[4], date: '15 Jan 2026', status: 'Delivered' },
    savedRoom: 'Living Room',
    cartItems: [MOCK_WALLPAPERS[0], MOCK_WALLPAPERS[3]],
    recentSearches: ['Floral bedroom wallpaper', 'Modern living room', 'Scenic mural'],
    wishlistItems: [MOCK_WALLPAPERS[1], MOCK_WALLPAPERS[5], MOCK_WALLPAPERS[7]],
    location: 'Mumbai',
    localTrending: [MOCK_WALLPAPERS[2], MOCK_WALLPAPERS[4], MOCK_WALLPAPERS[6], MOCK_WALLPAPERS[0]],
    mostClickedCategories: [
      { name: 'Modern', clicks: 24, image: 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-1733_0.jpg?generation=1768288053960446&alt=media' },
      { name: 'Scenic', clicks: 18, image: 'https://storage.googleapis.com/mahattaart-wallpaper/scenic.jpg' },
      { name: 'Florals', clicks: 12, image: 'https://storage.googleapis.com/static-mahattaart-online/wallpaper_lowres_new1/SM-Nouv-0027_0.jpg' },
    ],
    mostClickedProducts: [MOCK_WALLPAPERS[0], MOCK_WALLPAPERS[5], MOCK_WALLPAPERS[1]],
    viewHistory: [
      { page: 'Modern Collection', time: '2 hours ago', wallpaper: MOCK_WALLPAPERS[0] },
      { page: 'Scenic Mural — Alps Horizon', time: '5 hours ago', wallpaper: MOCK_WALLPAPERS[1] },
      { page: 'Living Room Designs', time: 'Yesterday', wallpaper: MOCK_WALLPAPERS[5] },
      { page: 'Silk Route Collection', time: 'Yesterday', wallpaper: MOCK_WALLPAPERS[3] },
    ],
  };

  get isNew() { return this.userType === 'new'; }
  get isExisting() { return this.userType === 'existing'; }

  constructor(public state: AppStateService, public router: Router, private wallpaperService: WallpaperService, private cdr: ChangeDetectorRef, private dataLayer: DataLayerService, private triggerService: TriggerService) { }

  ngOnInit() {
    this.startBannerSlide();
    this.sub.add(this.state.userType$.subscribe(t => this.userType = t));
    this.sub.add(this.state.context$.subscribe(c => this.context = c));
    this.sub.add(this.state.wishlistIds$.subscribe(ids => this.wishlistIds = ids));
    this.loadMastersData();
    this.dataLayer.pushHomepageView();
    this.startHeroAutoSlide();
    // T8 — return visitor with PDP history (30s on home, no cart yet)
    this.triggerService.homepageStartWatch();
  }

  getCategoryCardImage(cat: any): string {
    return cat.images?.[0] || '';
  }

  private loadMastersData() {
    this.loadExclusiveWallpapers();
    this.loadPopularWallpapers();
    // Categories and spaces sliders are fully hardcoded — no API calls needed
  }


  private loadCategoryThumbnails() {
    // Static map covers all categories — no extra API calls needed
  }

  
  private loadExclusiveWallpapers() {
    this.wallpaperService.getExclusiveWallpapers(20).subscribe({
      next: (res: any) => {
        const list: any[] = res?.data ?? res ?? [];
        this.exclusiveWallpapers = list.map(wp => {
          const imgs: string[] = [];
          if (wp.list_thumbnail) imgs.push(wp.list_thumbnail);
          if (wp.hover_thumbnail && wp.hover_thumbnail !== wp.list_thumbnail) imgs.push(wp.hover_thumbnail);
          if (wp.space1) imgs.push(wp.space1);
          if (wp.space2) imgs.push(wp.space2);
          if (wp.space3) imgs.push(wp.space3);
          return { ...wp, images: imgs.length > 0 ? imgs : [wp.list_thumbnail] };
        });
        this.rebuildExclusiveLoop();
        this.exclusiveLoading = false;
      },
      error: () => { this.exclusiveLoading = false; }
    });
  }

  // 3 copies for infinite scroll: [A][A][A]
  get exclusiveLoop(): any[] {
    const a = this.exclusiveWallpapers;
    return a.length > 0 ? [...a, ...a, ...a] : [];
  }

  private exclusiveLoopTimer: any;
  private rebuildExclusiveLoop() {
    clearTimeout(this.exclusiveLoopTimer);
    this.exclusiveLoopTimer = setTimeout(() => {
      this.cdr.detectChanges();
      setTimeout(() => this.setupExclusiveInfiniteScroll(), 200);
    }, 300);
  }

  private setupExclusiveInfiniteScroll() {
    const el = this.exclusiveScrollEl?.nativeElement;
    if (!el || this.exclusiveWallpapers.length === 0) return;

    // We have 3 copies: [A][A][A]. Start at copy 1 (middle).
    const oneSet = el.scrollWidth / 3;
    el.style.scrollBehavior = 'auto';
    el.scrollLeft = oneSet;
    el.style.scrollBehavior = 'smooth';

    let jumping = false;
    el.addEventListener('scroll', () => {
      if (jumping) return;
      requestAnimationFrame(() => {
        if (jumping) return;
        const setW = el.scrollWidth / 3;
        if (setW <= 0) return;
        if (el.scrollLeft >= setW * 2) {
          jumping = true;
          el.style.scrollBehavior = 'auto';
          el.scrollLeft -= setW;
          el.style.scrollBehavior = 'smooth';
          requestAnimationFrame(() => { jumping = false; });
        } else if (el.scrollLeft < 10) {
          jumping = true;
          el.style.scrollBehavior = 'auto';
          el.scrollLeft += setW;
          el.style.scrollBehavior = 'smooth';
          requestAnimationFrame(() => { jumping = false; });
        }
      });
    });
  }

  loadPopularWallpapers() {
    this.wallpaperService.getPopularWallpapers().subscribe({
      next: (res: any) => {
        // The old endpoint returned a bare array; the new one returns
        // { data, meta } like the rest of that backend. Unwrapping either way
        // keeps this working during the migration and after it, so the endpoint
        // can be switched back without touching this component.
        const list: any[] = Array.isArray(res) ? res : (res?.data ?? []);
        this.popularWallpapers = list.map((wp: any) => ({
          ...wp,
          display_image: this.getWallpaperImage(wp)
        }));
        this.popularLoading = false;
      },
      error: () => { this.popularLoading = false; }
    });
  }

  getWallpaperImage(wp: any): string {

    const fallbackImages = [
      wp.thumbnail,
      wp.space1,
      wp.space2,
      wp.space3,
      wp.space4
    ].filter(img => !!img);

    if (fallbackImages.length > 0) {
      const randomIndex = Math.floor(Math.random() * fallbackImages.length);
      return fallbackImages[randomIndex];
    }

    return wp.list_thumbnail;
  }

  navigateToExclusive(wp: any) {
    const slug = wp.slug || wp.wallpaper_id?.toLowerCase() || wp.id;
    this.router.navigate(['/pdp', slug]);
  }


  getCategoryImage(cat: any): string {
    const slug = (cat.slug || '').toLowerCase();
    const nameKey = (cat.display_name || cat.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    // 1. Static map by slug (exact) — always preferred
    if (this.categoryImages[slug]) return this.categoryImages[slug];
    // 2. Static map by normalized name
    if (this.categoryImages[nameKey]) return this.categoryImages[nameKey];
    // 3. Partial slug/name match in static map
    const keys = Object.keys(this.categoryImages);
    const partial = keys.find(k => slug.includes(k) || k.includes(slug) || nameKey.includes(k) || k.includes(nameKey));
    if (partial) return this.categoryImages[partial];
    // 4. Image field from category API response
    if (cat.image || cat.image_url || cat.thumbnail) return cat.image || cat.image_url || cat.thumbnail;
    return 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-1733_0.jpg?generation=1768288053960446&alt=media';
  }

  getCategoryFallback(cat: any): string {
    const slug = (cat.slug || '').toLowerCase();
    const nameKey = (cat.display_name || cat.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const keys = Object.keys(this.categoryImages);
    const key = this.categoryImages[slug] ? slug
      : this.categoryImages[nameKey] ? nameKey
        : keys.find(k => slug.includes(k) || k.includes(slug) || nameKey.includes(k) || k.includes(nameKey));
    return (key ? this.categoryImages[key] : null) || 'https://storage.googleapis.com/download/storage/v1/b/static-mahattaart-online/o/wallpaper%2Flist_thumbnail_MAWP-C-1733_0.jpg?generation=1768288053960446&alt=media';
  }

  getSpaceImage(space: any): string {
    // 1. Dynamic thumbnail loaded via search API
    if (this.spaceThumbnails[space.id]) return this.spaceThumbnails[space.id];
    // 2. Image field from static list or API response
    if (space.img || space.image || space.image_url || space.thumbnail) return space.img || space.image || space.image_url || space.thumbnail;
    // 3. Static map by slug (exact)
    const slug = space.slug || '';
    if (this.spaceImages[slug]) return this.spaceImages[slug];
    // 4. Static map by normalized name
    const nameKey = (space.display_name || space.category_name || space.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (this.spaceImages[nameKey]) return this.spaceImages[nameKey];
    // 5. Partial slug/name match
    const keys = Object.keys(this.spaceImages);
    const partial = keys.find(k => slug.includes(k) || k.includes(slug) || nameKey.includes(k) || k.includes(nameKey));
    if (partial) return this.spaceImages[partial];
    return 'https://storage.googleapis.com/mahattaart-wallpaper/Living%20Room.png';
  }

  getSpaceFallback(space: any): string {
    const slug = space.slug || '';
    const nameKey = (space.display_name || space.category_name || space.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const keys = Object.keys(this.spaceImages);
    const key = this.spaceImages[slug] ? slug
      : this.spaceImages[nameKey] ? nameKey
        : keys.find(k => slug.includes(k) || k.includes(slug) || nameKey.includes(k) || k.includes(nameKey));
    return (key ? this.spaceImages[key] : null) || 'https://storage.googleapis.com/mahattaart-wallpaper/Living%20Room.png';
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.fade-in-up, .fade-in-left, .fade-in-right, .fade-in-scale, .stagger-children')
      .forEach(el => this.observer.observe(el));

    // Build looped arrays once, then setup infinite scroll after DOM renders
    this.buildLoopedArrays();
    setTimeout(() => {
      this.setupInfiniteScroll(this.categoryScrollEl);
      this.setupInfiniteScroll(this.spaceScrollEl);
    }, 1000);

    // Start review auto-slide
    this.updateReviewVisibleCount();
    this.startReviewAutoSlide();
    window.addEventListener('resize', this.onReviewResize);
  }

  // Pre-built looped arrays — set once in ngAfterViewInit, never rebuilt
  loopedCategories: any[] = [];
  loopedSpaces: any[] = [];
  loopedExclusiveWallpapers: any[] = [];

  trackByIdx(index: number): number { return index; }

  private buildLoopedArrays() {
    const r = (arr: any[]) => [...arr, ...arr, ...arr, ...arr, ...arr];
    this.loopedCategories = r(this.hardcodedCategories);
    this.loopedSpaces = r(this.spaces);
    this.loopedExclusiveWallpapers = r(this.exclusiveWallpapers);
  }

  /**
   * Infinite scroll: content is [A][A][A][A][A] (5 copies).
   * Starts at copy 2. Jumps back/forward by 1 copy when reaching edges.
   * Uses COPIES=5 so user scrolls through 2 full sets before any jump.
   */
  private setupInfiniteScroll(elRef: ElementRef<HTMLDivElement>, copies: number = 5): void {
    const el = elRef?.nativeElement;
    if (!el || el.scrollWidth <= 0) return;

    const oneSet = el.scrollWidth / copies;
    // Start at copy 2
    el.scrollLeft = oneSet * 2;

    let jumping = false;
    el.addEventListener('scroll', () => {
      if (jumping) return;
      requestAnimationFrame(() => {
        if (jumping) return;
        const setW = el.scrollWidth / copies;
        if (setW <= 0) return;

        if (el.scrollLeft >= setW * (copies - 1)) {
          jumping = true;
          el.scrollLeft -= setW;
          requestAnimationFrame(() => { jumping = false; });
        } else if (el.scrollLeft < setW * 0.5) {
          jumping = true;
          el.scrollLeft += setW;
          requestAnimationFrame(() => { jumping = false; });
        }
      });
    });
  }

  // Review slider — handled by manual clone carousel

  startBannerSlide() {
    if (this.bannerSlides.length <= 1) return;
    clearInterval(this.bannerTimer);
    this.bannerTimer = setInterval(() => {
      this.bannerSlideIndex = (this.bannerSlideIndex + 1) % this.bannerSlides.length;
    }, 5000);
  }

  stopBannerSlide() {
    clearInterval(this.bannerTimer);
    this.bannerTimer = null;
  }

  startHeroAutoSlide() {
    this.stopHeroAutoSlide();
    this.heroAutoTimer = setInterval(() => {
      this.heroSlideIndex = (this.heroSlideIndex + 1) % this.heroBanners.length;
    }, this.heroAutoDelay);
  }

  stopHeroAutoSlide() {
    if (this.heroAutoTimer) {
      clearInterval(this.heroAutoTimer);
      this.heroAutoTimer = null;
    }
  }

  navigateToHeroBanner(banner: any) {
    this.router.navigate(['/pdp', banner.wallpaperId]);
  }

  // ── Review slider ────────────────────────────────────────────────
  /** Double array for seamless forward infinite loop */
  get displayReviews(): any[] { return [...this.reviews, ...this.reviews]; }

  private get maxReviewIndex(): number {
    return Math.max(0, this.reviews.length - this.reviewVisibleCount);
  }

  get reviewTranslateX(): number {
    return this.reviewSlideIndex * (100 / this.reviewVisibleCount);
  }

  updateReviewVisibleCount() {
    const prev = this.reviewVisibleCount;
    this.reviewVisibleCount = window.innerWidth >= 768 ? 3 : 2;
    if (prev !== this.reviewVisibleCount && this.reviewSlideIndex > this.maxReviewIndex) {
      this.reviewSlideIndex = this.maxReviewIndex;
    }
  }

  onReviewResize = () => { this.updateReviewVisibleCount(); }

  /**
   * Forward advance using clone technique:
   * displayReviews = [...reviews, ...reviews] (doubled)
   * Position reviews.length shows same content as position 0 → snap there silently
   */
  private doAdvance() {
    if (this.reviewSlideIndex + 1 >= this.reviews.length) {
      this.noTransition = false;
      this.reviewSlideIndex = this.reviews.length; // animate into clone zone
      setTimeout(() => {
        this.noTransition = true;
        this.reviewSlideIndex = 0;            // instant snap (same content)
        setTimeout(() => { this.noTransition = false; }, 50);
      }, 1000);
    } else {
      this.noTransition = false;
      this.reviewSlideIndex++;
    }
  }

  startReviewAutoSlide() {
    this.stopReviewAutoSlide();
    this.reviewAutoTimer = setInterval(() => { this.doAdvance(); }, this.reviewAutoDelay);
  }

  stopReviewAutoSlide() {
    if (this.reviewAutoTimer) { clearInterval(this.reviewAutoTimer); this.reviewAutoTimer = null; }
  }

  goToReview(index: number) {
    this.noTransition = false;
    this.reviewSlideIndex = Math.min(index, this.maxReviewIndex);
    this.startReviewAutoSlide();
  }

  nextReview() { this.doAdvance(); this.startReviewAutoSlide(); }

  prevReview() {
    if (this.reviewSlideIndex <= 0) {
      this.noTransition = true;
      this.reviewSlideIndex = this.maxReviewIndex;
      setTimeout(() => { this.noTransition = false; }, 50);
    } else {
      this.noTransition = false;
      this.reviewSlideIndex--;
    }
    this.startReviewAutoSlide();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    if (this.observer) this.observer.disconnect();
    this.stopBannerSlide();
    this.stopHeroAutoSlide();
    this.stopReviewAutoSlide();
    window.removeEventListener('resize', this.onReviewResize);
    this.triggerService.homepageStopWatch();
  }

  // Template passes the native HTMLElement via template ref var (#spaceScrollRef on a div)
  scrollNav(ref: HTMLDivElement, dir: 'left' | 'right') {
    ref?.scrollBy({ left: dir === 'left' ? -690 : 690, behavior: 'smooth' });
  }

  // ── Drag to scroll (Exclusive carousel) ──
  private exDragging = false;
  private exStartX = 0;
  private exScrollLeft = 0;

  onExclusiveDragStart(e: MouseEvent) {
    const el = this.exclusiveScrollEl?.nativeElement;
    if (!el) return;
    this.exDragging = true;
    this.exStartX = e.pageX - el.offsetLeft;
    this.exScrollLeft = el.scrollLeft;
    el.style.cursor = 'grabbing';
    el.style.scrollBehavior = 'auto';
  }

  onExclusiveDragMove(e: MouseEvent) {
    if (!this.exDragging) return;
    e.preventDefault();
    const el = this.exclusiveScrollEl?.nativeElement;
    if (!el) return;
    const x = e.pageX - el.offsetLeft;
    el.scrollLeft = this.exScrollLeft - (x - this.exStartX) * 1.5;
  }

  onExclusiveDragEnd() {
    if (!this.exDragging) return;
    this.exDragging = false;
    const el = this.exclusiveScrollEl?.nativeElement;
    if (el) {
      el.style.cursor = 'grab';
      el.style.scrollBehavior = 'smooth';
    }
  }

  openNurPanel() {

    this.state.toggleNur()

  }

  // For the API-driven sliders — passes ID for filtering in listing
  navigateToCategory(cat: any) {
    const catName = cat.display_name || cat.name || '';
    const idx = this.categories.indexOf(cat);
    this.dataLayer.pushSelectPromotion({
      id: cat.id ? `CAT_${cat.id}` : 'CAT',
      name: cat.display_name || cat.name || 'Category',
      creative: 'featured_tile',
      slot: 'category_section'
    });
    this.dataLayer.pushSectionClick({
      type: 'shop_by_style',
      value: catName,
      index: idx >= 0 ? idx + 1 : 1,
      source: 'wallpaper_landing'
    });
    // D4 — category_click
    this.dataLayer.pushCategoryClick({ category: catName, source: 'homepage', index: idx >= 0 ? idx + 1 : 1 });
    const slug = cat.slug || String(cat.id);
    this.router.navigate(['/wallpaper/category', slug], {
      queryParams: { sortby: 'id', sortdir: 'desc', category: categorySlugById(cat.id) || cat.id }
    });
  }

  navigateToSpace(space: any) {
    const spaceName = space.display_name || space.name || '';
    const idx = this.spaces.indexOf(space);
    this.dataLayer.pushSelectPromotion({
      id: space.id ? `SPACE_${space.id}` : 'SPACE',
      name: space.display_name || space.name || 'Space',
      creative: 'featured_tile',
      slot: 'space_section'
    });
    this.dataLayer.pushSectionClick({
      type: 'shop_by_space',
      value: spaceName,
      index: idx >= 0 ? idx + 1 : 1,
      source: 'wallpaper_landing'
    });
    // D3 — space_click
    this.dataLayer.pushSpaceClick({ space: spaceName, source: 'homepage', position: 'section', index: idx >= 0 ? idx + 1 : 1 });
    const slug = space.slug || String(space.id);
    this.router.navigate(['/wallpaper/space', slug], {
      queryParams: { sortby: 'id', sortdir: 'desc', space: spaceSlugById(space.id) || space.id }
    });
  }

  viewAllCategories() {
    this.router.navigate(['/listing'], {
      queryParams: { view: 'all-categories' }
    });
  }

  viewAllSpaces() {
    this.router.navigate(['/listing'], {
      queryParams: { view: 'all-spaces' }
    });
  }

  // Kept for existing static usages (quickRooms, existingUser sections)
  startWithSpace(space: string) {
    this.state.updateContext({ selected_space: space, selected_space_id: null, entry_point: 'space' });
    this.router.navigate(['/listing']);
  }

  startWithCategory(cat: string) {
    this.state.updateContext({ selected_category: cat, selected_category_id: null, entry_point: 'category' });
    this.router.navigate(['/listing']);
  }

  deepenMood(mood: string) {
    this.state.updateContext({ selected_mood: mood });
    this.router.navigate(['/listing']);
  }

  navigateSearch(query: string) {
    this.state.updateContext({ search_query: query, selected_space: null, selected_space_id: null, selected_category: null, selected_category_id: null, selected_mood: null, entry_point: null });
    this.router.navigate(['/listing']);
  }

  /**
   * "Reorder" from the returning-customer panel — opens the product page.
   *
   * It used to call `state.addToCart()`, which only pushed the wallpaper into the
   * local cart stream: no request was sent, the badge went up by one, and the
   * next cart load dropped it again. Nothing was ever reordered.
   *
   * A wallpaper on its own is not a cart line either — the size, the paper and
   * the service choices are what make it one, and they are priced on the PDP. So
   * this sends the customer there with the wallpaper they picked, which is the
   * shortest honest path to the same outcome.
   */
  addToCart(wp: Wallpaper) {
    this.router.navigate(['/pdp', wp.id]);
  }

  resetContext() {
    this.state.updateContext({ selected_space: null, selected_space_id: null, selected_category: null, selected_category_id: null, selected_mood: null, entry_point: null });
  }

  openNur() {
    this.state.toggleNur();
  }

  navigateCustomUpload() {
    this.router.navigate(['/custom-upload']);
  }

  navigateCustomDesign() {
    this.router.navigate(['/custom-design']);
  }
scrollToSection(id: string) {
  const element = document.getElementById(id);
  const headerOffset = 120; // apne header ki height (approx)

  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

  getClickBarWidth(cat: any): string {
    return `${(cat.clicks / this.existingUser.mostClickedCategories[0].clicks) * 100}%`;
  }

  isLastViewItem(idx: number): boolean {
    return idx < this.existingUser.viewHistory.length - 1;
  }
}
